
<div class="flow-toggle-box" :selected="selected" @click="handleClick($event)">
	<slot />
</div>
